<template>
	<div>
		<!-- banner -->
		<div class="banner">
			<!-- <el-carousel :height="bannerHeight+'px'"> -->
			<el-carousel :height="bannerHeight+'px'">
				<el-carousel-item style="width:100%;height: auto" v-for="(item, index) in sliders" :key="index">
					<img style="width:100%;height: auto;vertical-align: middle;" :src="item.img" class="slider_img"
						@click="getOpenMinChengXuLink">
				</el-carousel-item>
			</el-carousel>
		</div>
		<!-- 公司简介 -->
		<div id="profile" class="introduction">
			<div class="head-label-in">
				<div class="f36">公司简介</div>
				<div class="f14 red">COMPANY INTRODUCTION</div>
			</div>
			<div class="introduction_con">
				<p class="align-center">深圳市金信泰典当有限公司成立于2013年<br/>是一家经国家金融监督管理局批准的专业典当服务机构，为深圳市典当协会会员单位，总部位于深圳福田区。多年来，我们始终乘承“诚信为本、服务至上”的经营<br/>理念，致力于为个人和企业客户提供高效、灵活的融资解决方案。凭借专业的团队和优质的服务，金信泰典当已成为国内典当行业的知名品牌</p>
				<div class="intro-list">
					<div class="intro-item">
						<p class="f36 red align-center">1000W</p>
						<p class="f18 align-center">注册资金</p>
					</div>
					<div class="intro-item">
						<p class="f36 red align-center">2000家</p>
						<p class="f18 align-center">助力中小企业</p>
					</div>
					<div class="intro-item">
						<p class="f36 red align-center">50000次</p>
						<p class="f18 align-center">办理业务</p>
					</div>
				</div>
				<!-- <div class="more_btn">了解更多</div> -->
			</div>
		</div>
		<!-- 企业荣誉 -->
		<div id="honor" class="head-label">
			<div class="f36">企业荣誉</div>
			<div class="f14 red">CORPORATE HONOR</div>
		</div>
		<div class="border_parent honor">
			<img src="../../static/walkInto/honor.png" alt="" />
		</div>
		<!-- 发展历程 -->
		<div ref="development" id="development" class="introduction mt-60">
			<div class="head-label-in">
				<div class="f36">发展历程</div>
				<div class="f14 red">DEVELOPMENT HISTORY</div>
			</div>
			<div class="border_parent history_con">
				<img class="dev-img" src="../../static/walkInto/devlopment.png" alt="" />
			</div>
		</div>
		<!-- 人才招聘 -->
		<div id="recruitment" class="hire">
			<div class="head-label-hire">
				<div class="f36">人才招聘</div>
				<div class="f14 red">RECRUITMENT</div>
			</div>
			<div class="border_parent " @click="goRecruitment()">
				<div class="hire-list">
					<div class="hire-item">
						<img class="hire-item-img" src="../../static/hire/hire2.png" alt="" />
					</div>
					<div class="hire-item">
						<img class="hire-item-img" src="../../static/hire/hire1.png" alt="" />
					</div>
				</div>
			</div>
		</div>
		<!-- 金信泰门店 -->
		<Address id="store"></Address>
	</div>
</template>
<script>	
	import Address from '../components/Address.vue'
	import {
		encryptLong,
		syShopSign
	} from '@/utils/rsaEncrypt'
	export default {
		name: 'Index',
		components: {Address},
		data() {
			return {
				timer: '',
				userName: '',
				phoneNumber: '',
				// 容器的高度
				bannerHeight: 0,
				// 瀏覽器寬度
				screeWith: 0,
				sliders: [],
				hireArr: [{
					title: '客户经理',
					address: '合肥',
					des: '有经验者优先'
				},
				{
					title: '业务转化专员',
					address: '合肥',
					des: '有经验者优先'
				},],
				historyArr: [{
					year: "2025",
					des:'公司成立，显示一句简介公司成立，显示一句'
				},
				{
					year: "2025",
					des:'公司成立，显示一句简介公司成立，显示一句'
				},
				{
					year: "2025",
					des:'公司成立，显示一句简介公司成立，显示一句'
				},
				{
					year: "2025",
					des:'公司成立，显示一句简介公司成立，显示一句'
				},
				{
					year: "2025",
					des:'公司成立，显示一句简介公司成立，显示一句'
				},
				{
					year: "2025",
					des:'公司成立，显示一句简介公司成立，显示一句'
				}],
				// carousel_height: '550px',
			}
		},
		created() {
			// this.backTop()
		},
		methods: {
			backTop() { //当点击标签的时候,使用animate在200毫秒的时间内,滚到顶部
				this.timer = setInterval(() => {
					let osTop = document.documentElement.scrollTop || document.body.scrollTop;
					let ispeed = Math.floor(-osTop / 5)
					document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
					if (osTop === 0) {
						clearInterval(this.timer)
					}
				}, 30)
			},
			scrollToForm() {
			    this.$refs.development.scrollIntoView({ behavior: 'smooth' })
			},
			// 人才招聘-我要加入
			goRecruitment() {
				this.$router.push({
					path: '/hire',
				}, onComplete => {}, onAbort => {})
			},
			getOpenMinChengXuLink() {
				if (this.isMobile()) {
					let url = '/sy/aboutUs/getScheme';
					const timeStamp = new Date().getTime();
					const sySign = syShopSign();
					const CheckCsrf = encryptLong(sySign + timeStamp);
					this.axios.get(url, {
						headers: {
							'TimeStamp': timeStamp,
							'CheckCsrf': CheckCsrf,
							'Content-Type': 'application/x-www-form-urlencoded'
						}
					}).then(res => {
						location.href = res.data.data;
					})
				} else {
					console.log('pc端不跳转')
					return;
				}

			},
			// 判断是否是手机端，如果是，返回true
			isMobile() {
				let flag = navigator.userAgent.match(
					/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
				)
				return flag
			}
		},
		mounted() {
			this.sliders = [{
				img: require("../../static/walkInto/banner01.png")
			}],
			// 首次加載時，初始化高度
			this.screeWith = window.innerWidth
			this.bannerHeight = 400 / 1920 * this.screeWith
			// 窗口大小發生變化
			window.onresize = () => {
				this.screeWith = window.innerWidth
				this.bannerHeight = 400 / 1920 * this.screeWith
			}
		},
		computed: {
			//计算高度
			// computeHeight() {
			//     let screenHeight = document.body.clientWidth;
			//     if (screenHeight > 415) {
			//         return '550px';
			//     } else {
			//         return '250px';
			//     }
			// },
			computeArrowImg() {
				let screenHeight = document.body.clientWidth;
				if (screenHeight > 450) {
					return require('../../static/other/arrow.png');
				} else {
					return require('../../static/other/arrow_down.png');
				}
			}

		},
	}
</script>

<style scoped>
	.hire-item-img {
		width: 590px;
		height: 387px;
	}
	/* 清除banner滾動條 */
	.el-carousel--horizontal {
		overflow-x: hidden;
		overflow-y: hidden;
	}

	.el-carousel__indicator.is-active {
		border-bottom: 2px solid #DF9C03 !important;
	}
	
	.slider_img {
		height: 560px;
		width: 100%;
	}

	/* banner FORM style */
	.banner {
		position: relative;
	}
	
	
	.solve {
		margin-top: 30px;
		margin-bottom: 10px
	}

	.border {
		border-radius: 6px;
		border: 1px solid #EBEEF5;
		height: auto;
		margin: 10px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
	}

	.border_one {
		margin-left: 0;
	}

	.border_img_parent {
		margin-top: 20px;
		display: flex;
		justify-content: center;
	}

	.product_mobile_content {
		height: 300px;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
	}

	.product_mobile_img {
		width: 50%;
	}

	.product_mobile_title {
		font-weight: bold;
		text-align: center;
	}

	.product_pc_one {
		text-align: center;
		min-height: 400px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}

	.font_size_30 {
		font-size: 1.875rem;
	}

	.product_font_style {
		font-size: 1.125rem;
	}

	.product_pc_img {
		width: 100%
	}

	.product_pc_img_div {
		width: 50%;
		float: left;
		display: flex;
		align-items: center;
	}

	.product_pc {
		display: flex;
		width: 90%;
		margin: 20px auto;
		background: #F2F6FC;
		align-items: center;
	}

	.product_spec_title {
		margin-top: 30px;
		margin-bottom: 10px
	}

	.product_spec_parent {
		display: flex;
		width: 90%;
		margin: 20px auto;
		align-items: center;
		height: auto
	}

	.cooperation_parent {
		display: flex;
		justify-content: center;
		width: 90%;
		margin: 20px auto;
		align-items: center;
		height: auto
	}

	.border_spec {
		border-radius: 6px;
		border: 1px solid #EBEEF5;
		float: left;
		width: 25%;
		height: auto;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
	}

	.about_me_p {
		font-size: 1.25rem;
		font-weight: normal;
		padding: 0 20px;
		margin: 10px;
	}

	.border_title {
		font-family: "PingFang SC";
		margin-top: 10px;
		font-size: 1.125rem;
		font-weight: bold;
		text-align: center;
	}

	.border_content_one {
		margin-top: 20px;
		font-size: 1.125rem;
		text-align: center;
	}

	.border_content_two {
		margin-top: 5px;
		font-size: 1.125rem;
		margin-bottom: 25px;
		text-align: center;
	}

	.img_border {
		margin-top: 15px;
		width: 80px;
		height: 80px
	}

	.border_spec_inner_one {
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: 35px;
		height: 70px;
	}

	.border_spec_content_one {
		margin-top: 15px;
		font-size: 1.125rem;
		float: left;
		text-align: center;
	}

	.border_spec_inner_last {
		margin-top: 15px;
		font-size: 1.125rem;
		float: left;
		margin-bottom: 25px;
		text-align: center;
	}

	.cooperation {
		margin-top: 30px;
		width: 100%;
	}

	.about_me {
		display: flex;
		margin-top: 30px;
		justify-content: center;
		width: 100%;
	}

	.product_mobile {
		width: 90%;
		align-items: center;
		margin: 20px auto;
		background: #F2F6FC;
	}

	.product_mobile_img_div {
		width: 50%;
		height: auto;
	}

	.product_mobile_content_one {
		margin-top: 20px;
		text-align: center;
	}

	.product_mobile_content_two {
		margin-top: 10px;
		text-align: center;
	}

	/* 屏幕设备适配 max-device-width: 400px */
	@media screen and (max-device-width: 415px) {
		.slider_img {
			height: 250px;
			width: 100%;
		}


		.border_parent {
			display: flex;
			width: 90%;
			margin: auto;
			height: auto;
			flex-direction: column;
		}

		.border {
			border-radius: 6px;
			border: 1px solid #EBEEF5;
			float: left;
			width: 100%;
			height: auto;
			margin: 10px 0 auto;
			box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
				/*background: aquamarine;*/
		}

		.border_img_parent {
			margin-top: 0;

		}

		.product_mobile {
			width: 90%;
			align-items: center;
			margin: 20px auto;
			height: auto;
			background: #F2F6FC;
		}

		.product_mobile_content {
			width: 100%;
			margin-top: 15px;
		}

		.product_mobile_content_one {
			margin-top: 5px;
		}

		.product_mobile_content_two {
			margin-top: 5px;
		}

		.product_mobile_img_div {
			display: flex;
			width: 100%;
			height: auto;
			justify-content: center;
			margin-top: 10px;
			margin-bottom: 15px;
		}

		.product_mobile_img {
			float: left;
		}

		.product_mobile_title {
			font-weight: bold;
		}

		.product_pc_one {
			width: 100%;
			margin-top: 15px;
		}

		.font_size_30 {
			font-size: 1.25rem;
		}

		.product_font_style {
			font-size: 1rem;
		}

		.product_pc_img {
			height: 280px;
			width: 320px;
		}

		.product_pc_img_div {
			width: 100%;
			float: left;
			display: flex;
			align-items: center;
			justify-content: center;
			margin-bottom: 15px;
		}

		.product_pc {
			display: flex;
			width: 90%;
			height: auto;
			margin: 20px auto;
			background: #F2F6FC;
			flex-direction: column;
		}

		

		.product_spec_parent {
			display: flex;
			width: 90%;
			align-items: center;
			justify-content: center;
			margin: 20px auto;
			height: auto;
			flex-direction: column;
		}

		.border_spec {
			float: left;
			height: auto;
			margin: 8px;
			width: 100%;
			border-radius: 6px;
			border: 1px solid #EBEEF5;
			box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
		}


		.border_title {
			font-family: "PingFang SC";
			margin-top: 5px;
			font-size: 1.125rem;
			font-weight: bold;
		}

		.border_content_one {
			margin-top: 5px;
			font-size: 1.125rem;
		}

		.border_content_two {
			margin-top: 5px;
			font-size: 1.125rem;
			margin-bottom: 8px;
		}

		.img_border {
			margin-top: 8px;
			width: 80px;
			height: 80px
		}

		.border_spec_inner_one {
			display: flex;
			justify-content: center;
			align-items: center;
			margin-top: 8px;
			/*background-color: aqua;*/
			height: 70px;
		}

		.border_spec_content_one {
			margin-top: 5px;
			font-size: 1.125rem;
			float: left;
		}

		.border_spec_inner_last {
			/*background-color: bisque;*/
			margin-top: 5px;
			font-size: 1.125rem;
			float: left;
			margin-bottom: 8px;
		}

		.about_me {
			display: flex;
			margin-top: 10px;
			width: 100%;
		}
	}

	.border_spec_img {
		width: 75px;
		height: 55px;
		align-self: center
	}

	.font_size_24 {
		font-size: 1.5rem;
	}
</style>


// WEBPACK FOOTER //
// src/view/walkInto.vue